import React, { useState } from 'react';
import classnames from 'classnames';
import './index.scss';
import SvgIcon from '../../images/svg/index';

const navs = [{
  label: '车身三维',
  value: 'size',
  icon: 'side-btn-icon1.png'
  // icon: '\ue60b'
}, {
  label: '车辆热点',
  value: 'annotations',
  icon: 'side-btn-icon2.png'
  // icon: '\ue608'
}, {
  label: '车灯开关',
  value: 'headlight',
  icon: 'side-btn-icon4.png'
  // icon: '\ue608'
}, {
  label: '音乐开关',
  value: 'music',
  icon: 'side-btn-icon3.png'
  // icon: '\ue606'
}];

export default function Side({ handleSideNav, style, actives }) {
  const [ open, setOpen ] = useState(false);

  return (
    <div className="side-wrapper" style={style}>
      <div className="text-box" onClick={() => setOpen(!open)}>
        <div className="shadow-box"></div>
        <p className="text">选项</p> 
      </div>
      <ul className={classnames("side-list", { open })}>
        {navs.map(v => 
          <li
            key={v.value}
            onClick={(event) => {
              event.preventDefault()
              handleSideNav(v.value)
            }}
          > 
            <div className="shadow-box"></div>
            <div className={classnames("inner", {
              "active": actives[v.value],
              [v.value]: true
            })}>
              <SvgIcon icon={ actives[v.value] ? v.value : 'on-' + v.value}></SvgIcon>
              <p className="text">{ v.label }</p>
            </div>
          </li>
        )}
      </ul>
      <button className={classnames("side-collapse-btn", { open })} onClick={() => setOpen(!open)}>
        <i className="icon-font">
          {open ? '\ue614' : '\ue613'}
        </i>
      </button>
    </div>
  )
}  